export default {
  getPlatform(input: string): string {
    const platform = input.trim().toLowerCase() as Platform;
    if (platform === 'android' || platform === 'ios') {
      if (!(this.hasAndroidFunction() || this.hasIOSFunction())) {
        return 'mweb';
      }
    }

    return platform;
  },

  isApp(): boolean {
    return this.hasAndroidFunction() || this.hasIOSFunction();
  },

  /**
   * Android WebView determines whether there is a function for transmitting log data.
   *
   * @returns {boolean} Returns true if window.CoupangAppTracking.logEvent is present, false otherwise.
   */
  hasAndroidFunction(): boolean {
    return typeof window?.CoupangAppTracking?.logEvent === 'function';
  },

  /**
   * iOS WebView determines whether there is a function for transmitting log data.
   *
   * @returns {boolean} Returns true if window.webkit.messageHandlers.callBackHandler.postMessage is present, false otherwise.
   */
  hasIOSFunction(): boolean {
    return typeof window?.webkit?.messageHandlers?.callBackHandler?.postMessage === 'function';
  }
}
